import Cookies from 'js-cookie';
import { useMemo } from 'react';

import { parseFirstVisitTimestamp } from './parseFirstVisitTimestamp';
import { ONBOARDING_FIRST_VISIT_COOKIE_NAME } from '../../constants/cookies';

interface IOnboardingFirstVisitTimestamp {
  firstVisitTimestamp: number | undefined;
  shouldPersistFirstVisitTimestamp: boolean;
}

export function useOnboardingFirstVisitTimestamp(isMobile: boolean): IOnboardingFirstVisitTimestamp {
  return useMemo(() => {
    if (!isMobile) {
      return { firstVisitTimestamp: undefined, shouldPersistFirstVisitTimestamp: false };
    }
    const now = Date.now();
    const savedTimestamp = parseFirstVisitTimestamp(Cookies.get(ONBOARDING_FIRST_VISIT_COOKIE_NAME), now);
    if (savedTimestamp !== null) {
      return { firstVisitTimestamp: savedTimestamp, shouldPersistFirstVisitTimestamp: false };
    }

    return { firstVisitTimestamp: now, shouldPersistFirstVisitTimestamp: true };
  }, [isMobile]);
}
